/* ==========================================================================================
   PDP A/B test - variant "NEW - B" buy box (Stability Blend)
   Pairs with snippets/pdp-b-buybox.liquid + assets/pdp-b-buybox.css.
   A and B render on the same page; B only acts on shared UI (sticky bar, media) while it is
   live, i.e. while A's .pdp-ab-a wrapper is hidden by Intelligems (see the inline switch script).
   - Grind combo-box (dropdown on desktop, bottom sheet on phones) + bag size tiles + plan cards
   - Keeps the theme form (same id as variant A) in sync: name="id", name="selling_plan"
   - Fires the theme's "variant:changed" event so media, sticky ATC and payment terms follow
   - Savings line, per-cup prices, review carousel, FAQ accordions, lab + gifts modals
   No dependencies (no jQuery). Safe to load once per page; supports several blocks.
   ========================================================================================== */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '£{{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': v = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = withDelims(cents, 2, "'", '.'); break;
      default: v = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }
  function moveToBody(el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); }

  /* ---------- the Skio "Your Free Monthly Gifts" data (copied from assets/skio-plan-picker-component.js, BC30) ---------- */
  var IMG = 'https://cdn.shopify.com/s/files/1/0975/5482/5557/files/';
  var GIFTS = [
    { label: 'MONTH 1', items: [{ gift: 'Barista Course', price: '£10', img: IMG + 'barista-skills-course_afe2429a-d72c-4600-82a6-bd80eb773a57.jpg' }] },
    { label: 'MONTH 2', items: [{ gift: "Lion's Mane Elixir", price: '£15', img: IMG + 'lions-mane-mushroom-tincture-t_18af12f0-c6b2-403a-a99b-437728e4a022.webp' }, { gift: 'Mental Clarity Guide', price: '£10', img: IMG + 'newmethodclairty_98a3b507-0a77-4351-9b47-fa9e577ff7bf.jpg' }] },
    { label: 'MONTH 3', items: [{ gift: 'Hydration Guide', price: '£10', img: IMG + 'Frame_1707479645.png' }] },
    { label: 'MONTH 4', items: [{ gift: 'Chaga Elixir', price: '£15', img: IMG + 'chaga-mushroom-tincture-best_249961e8-c20c-482a-86b3-ae6263998c30.jpg' }, { gift: 'Mushroom Blueprint Guide', price: '£10', img: IMG + 'coffeeandmushroomblueprint_78a9828c-581f-4fab-a598-e461c9efa8e9.jpg' }] },
    { label: 'MONTH 5', items: [{ gift: 'Cordyceps Elixir', price: '£15', img: IMG + 'cordyceps-mushroom-tincture1_5fc403da-5947-41e7-b3de-a64d5dc766a1.jpg' }] },
    { label: 'MONTH 6', items: [{ gift: 'Reishi Elixir', price: '£15', img: IMG + 'reish-mushroom-tincture-1_62468bda-529d-4106-9d16-e6895aced0e4.jpg' }, { gift: 'Detox Guide', price: '£10', img: IMG + 'removing-toxins_88b6f2ac-b405-471c-9e4e-71d2f29f2836.jpg' }] },
    { label: 'MONTH 8', items: [{ gift: "Lion's Mane Elixir", price: '£15', img: IMG + 'lions-mane-mushroom-tincture-t_18af12f0-c6b2-403a-a99b-437728e4a022.webp' }, { gift: 'Stability Blend 250g', price: '£15', img: IMG + 'stability-blend-thumb_daac6b23-4619-42bf-9394-308a720ed8af.webp' }] },
    { label: 'MONTH 12', items: [{ gift: 'Gold Blend 250g', price: '£15', img: IMG + 'limited-ed-coffee_34ddae63-f6a1-440d-90c7-9bc89af6abb1.jpg' }, { gift: 'Longevity Guide', price: '£10', img: IMG + 'longevity-blueprint_b8cee009-85d5-4ad7-8e6c-ff910c8e67b3.jpg' }, { gift: 'Rotate Espresso 250g', price: '£14.99', img: IMG + 'rotate-espresso-thumb_794bb64f-6c49-40f3-bf82-218cacd18d36.webp' }] },
    { label: 'MONTH 14', items: [{ gift: 'Gift Voucher £10', price: '£10', img: IMG + 'best-list-christmas-coffee-gifts.jpg' }, { gift: 'Sleep Guide', price: '£10', img: IMG + 'sleepdeeper_stressless_9647aea1-5e74-452a-9484-389587797c17.jpg' }] },
    { label: 'MONTH 16', items: [{ gift: 'Calm Coffee 250g', price: '£15', img: IMG + 'CalmCoffeeBagMockup1kg_1.jpg' }] },
    { label: 'MONTH 18', items: [{ gift: 'Darkfire Energy 250g', price: '£15', img: IMG + 'darkfire-energy-dark-roast_dfe7a237-684c-4703-b9bf-1d1adc4c3091.webp' }] },
    { label: 'MONTH 24', items: [{ gift: 'Mystery Blend', price: '£15', img: IMG + 'Frame_1707479646_1.png' }, { gift: 'Aurora Single Origin 250g', price: '£20.99', img: IMG + 'esmerelda-single-origin-thumb_0dc8d506-6a81-4d4f-9b99-bd27196f8641.webp' }] }
  ];

  function init(root) {
    if (root._pdpb) return;
    root._pdpb = true;

    var jsonEl = $('[data-pdpb-json]', root);
    if (!jsonEl) return;
    var cfg;
    try { cfg = JSON.parse(jsonEl.textContent); } catch (e) { console.warn('[pdp-b] bad JSON', e); return; }

    var form = document.getElementById(root.getAttribute('data-form-id'));
    if (!form) return;
    var aFormId = root.getAttribute('data-a-form-id');
    var isLive = function () { return root.classList.contains('pdp-ab-live') || !!(window.Shopify && Shopify.designMode); };
    var idIn = form.querySelector('[name="id"]');
    var spIn = form.querySelector('[name="selling_plan"]');
    var atc = $('[data-atc]', root);
    var atcLabel = $('[data-atc-label]', root);
    /* button copy: "Subscribe & Save" while the subscription is selected, "Add to cart" for one-time */
    var atcText = function () { return state.plan === 'sub' ? (cfg.atcSubLabel || 'Subscribe & Save') : (cfg.atcLabel || 'Add to cart'); };
    var gi = cfg.grindIdx, si = cfg.sizeIdx;
    var fmt = cfg.moneyFormat;
    var money = function (c) { return formatMoney(c, fmt); };

    function byId(id) { for (var i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].id === id) return cfg.variants[i]; return null; }
    function match(grind, size) {
      var list = cfg.variants, i, v;
      for (i = 0; i < list.length; i++) {
        v = list[i];
        if ((gi < 0 || v.options[gi] === grind) && (si < 0 || v.options[si] === size)) return v;
      }
      return null;
    }
    function anyWithSize(size) {
      for (var i = 0; i < cfg.variants.length; i++) if (si < 0 || cfg.variants[i].options[si] === size) return cfg.variants[i];
      return null;
    }
    /* subscription price for the chosen Skio plan (frequency); falls back to the default plan's price */
    function subOf(v) {
      if (!v) return null;
      if (v.subs && state && state.planId != null && v.subs[state.planId] != null) return v.subs[state.planId];
      return v.sub != null ? v.sub : null;
    }
    function priceOf(v, plan) { if (!v) return 0; var s = subOf(v); return plan === 'sub' && s != null ? s : v.price; }
    /* "57p" under £1, "£1.20" above (savings line: "Best price: just 57p a cup") */
    function pence(c) { return c < 100 ? Math.round(c) + 'p' : money(c); }

    var start = byId(Number(idIn.value)) || cfg.variants[0];
    var state = {
      grind: gi >= 0 ? start.options[gi] : null,
      size: si >= 0 ? start.options[si] : null,
      plan: cfg.planId ? (root.getAttribute('data-plan') || 'once') : 'once',
      grindChosen: !!cfg.grindChosen,
      variantId: start.id,
      planId: cfg.planId
    };

    /* ---------- elements ---------- */
    var tiles = $$('.nw-size', root);
    var sizes = tiles.map(function (t) {
      return { el: t, value: t.getAttribute('data-size'), cups: Number(t.getAttribute('data-cups')) || 0, unit: t.getAttribute('data-unit') || 'cup', grams: Number(t.getAttribute('data-grams')) || 0, label: ($('.w', t) || t).textContent.trim() };
    });
    var subCard = $('.nw-subcard', root);
    var onceRow = $('.nw-plan[data-plan-opt="once"]', root);
    var subPriceEl = $('[data-sub-price]', root);
    var subOrigPriceEl = $('[data-sub-orig-price]', root);
    var subSaveEl = $('[data-sub-save]', root);
    var savingEl = $('[data-sub-saving]', root), savingAmt = $('[data-sub-saving-amt]', root);
    var oncePriceEl = $('[data-once-price]', root);
    var fullPriceEl = $('[data-full-price]', root);
    var kgSubEl = $('[data-kg-sub]', root), kgOnceEl = $('[data-kg-once]', root);
    var subTitleEl = $('[data-sub-title]', root);
    var freqSel = $('[data-freq]', root), freqLabel = $('[data-freq-label]', root);
    var saveWrap = $('[data-savings]', root);
    var saveInner = $('[data-savings-inner]', root);
    var gErr = $('[data-grind-error]', root);
     /* ---------- sticky add-to-cart button text (while B is live) ----------
       Skio's plan picker and the theme's "sticky-strike" script both write straight
       into #StickyAddToCart's .loader-button__text, scoped to A, with no idea B exists.
       While B is live we own that text and rebuild it the same way A's does: the label
       + price, plus a struck-through "was" price when the subscription plan is selected. */
    var stickyLabel = '';
    var stickyCompare = '';
    function stickyBtns() { return $$('#StickyAddToCart'); }
    function textOnly(node) {
      var out = '';
      for (var i = 0; i < node.childNodes.length; i++) {
        if (node.childNodes[i].nodeType === 3) out += node.childNodes[i].nodeValue;
      }
      return out;
    }
    function paintSticky() {
      if (!isLive()) return;
      stickyBtns().forEach(function (btn) {
        var node = btn.querySelector('.loader-button__text') || btn;
        var strikeEl = node.querySelector('.sticky-strike');
        var labelOk = textOnly(node) === stickyLabel;
        var compareOk = (strikeEl ? strikeEl.textContent : '') === stickyCompare;
        if (labelOk && compareOk) return; /* already correct - leave DOM alone */
        while (node.firstChild) node.removeChild(node.firstChild);
        node.appendChild(document.createTextNode(stickyLabel));
        if (stickyCompare) {
          var span = document.createElement('span');
          span.className = 'sticky-strike'; /* reuses the theme's existing strike styling */
          span.textContent = stickyCompare;
          node.appendChild(span);
        }
      });
    }
    function syncStickyAtc(v, price) {
      if (!v) { stickyLabel = cfg.unavailable || 'Unavailable'; stickyCompare = ''; }
      else if (!v.available) { stickyLabel = cfg.soldOut || 'Sold out'; stickyCompare = ''; }
      else {
        stickyLabel = atcText() + ' - ' + money(price);
        /* struck "was" price only while Subscribe is selected, same rule as A's widget */
        stickyCompare = (state.plan === 'sub' && subOf(v) != null) ? money(v.price) : '';
      }
      paintSticky();
      [30, 120, 350, 800].forEach(function (ms) { setTimeout(paintSticky, ms); });
      stickyBtns().forEach(function (btn) {
        if (btn._pdpbObserved) return;
        btn._pdpbObserved = true;
        new MutationObserver(paintSticky).observe(btn, { childList: true, characterData: true, subtree: true });
      });
    }
    /* ---------- render ---------- */
    function sizeObj(val) { for (var i = 0; i < sizes.length; i++) if (sizes[i].value === val) return sizes[i]; return null; }
    function tileVariant(sizeVal) { return match(state.grind, sizeVal) || anyWithSize(sizeVal); }

    /* Savings line (design 29 Sep): forward saving only, like-for-like, and a button that selects the next step.
       One-time: "Upgrade to 500g: save £4.99" / "Upgrade to 1kg: save £9.99" / 1kg "Subscribe: save £6.00"
       Subscription: "Upgrade to 500g: save £4.24" / "Upgrade to 1kg: save £8.49" / 1kg "Best price: just 57p a cup" */
    function renderSavings(v) {
      if (!saveWrap) return;
      var z = sizeObj(state.size), idx = sizes.indexOf(z), nx = idx > -1 ? sizes[idx + 1] : null;
      saveInner.innerHTML = '';
      var show = false;
      var addBtn = function (lead, amount, onClick) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'nw-ss-go is-simple';
        b.appendChild(document.createTextNode(lead + ': '));
        var st = document.createElement('strong'); st.textContent = 'save ' + money(amount); b.appendChild(st);
        b.appendChild(document.createTextNode(' \u2192'));
        b.addEventListener('click', onClick);
        saveInner.appendChild(b); show = true;
      };
      if (z && nx && z.grams && nx.grams) {
        /* next size vs buying the current size k times on the same plan (500g vs 2 x 250g) */
        var k = nx.grams / z.grams;
        var save = Math.round(k * priceOf(tileVariant(z.value), state.plan) - priceOf(tileVariant(nx.value), state.plan));
        if (save > 0) addBtn('Upgrade to ' + nx.label, save, function () { setSize(nx.value); });
      } else if (state.plan !== 'sub' && v && subOf(v) != null && cfg.planId) {
        var s2 = v.price - subOf(v);
        if (s2 > 0) addBtn('Subscribe', s2, function () { setPlan('sub'); });
      } else if (state.plan === 'sub' && v && subOf(v) != null && z && z.cups) {
        var sp = document.createElement('span'); sp.className = 'nw-ss-best';
        sp.appendChild(document.createTextNode('You have unlocked our best price: '));
        var st2 = document.createElement('strong'); st2.textContent = 'just ' + pence(subOf(v) / z.cups) + ' a cup'; sp.appendChild(st2);
        saveInner.appendChild(sp); show = true;
      }
      saveWrap.hidden = !show;
    }

    function render(opts) {
      opts = opts || {};
      var v = match(state.grind, state.size);

      /* some sizes have no subscription plan (e.g. 500g taster packs): hide the Subscribe card and switch to
         one-time; if the shopper had chosen Subscribe, it comes back when they pick a size that has one */
      var subOK = !!(cfg.planId && v && subOf(v) != null);
      if (!subOK && state.plan === 'sub') { state.plan = 'once'; state.subWanted = true; }
      else if (subOK && state.subWanted) { state.plan = 'sub'; state.subWanted = false; }
      if (subCard) subCard.hidden = !!v && !subOK;

      /* size tiles: checked state + per-cup for the current plan */
      sizes.forEach(function (s) {
        s.el.setAttribute('aria-checked', String(s.value === state.size));
        var pc = $('[data-pc]', s.el);
        var tv = tileVariant(s.value);
        if (pc && tv && s.cups) pc.textContent = money(Math.round(priceOf(tv, state.plan) / s.cups)) + '/' + s.unit;
      });

      /* plan cards */
      if (subCard) subCard.setAttribute('aria-checked', String(state.plan === 'sub'));
      if (onceRow) onceRow.setAttribute('aria-checked', String(state.plan !== 'sub'));
        if (v) {
        var sv = subOf(v);
        var shipBen = $('[data-ship-ben]', root);
        if (shipBen) shipBen.hidden = (sv != null ? sv : v.price) <= 2500;
        if (subPriceEl && sv != null) subPriceEl.textContent = money(sv);
        if (subOrigPriceEl) {
          if (sv != null && sv !== v.price) {
            subOrigPriceEl.textContent = money(v.price);
            subOrigPriceEl.hidden = false;
          } else {
            subOrigPriceEl.hidden = true;
          }
        }
        if (subSaveEl) subSaveEl.hidden = true; /* no Save pill (James 26 Sep) */
        /* "Saving £X" tag under the subscription price (design 21 Oct): one-time price minus subscription price */
        if (savingEl) {
          var sav = sv != null ? v.price - sv : 0;
          savingEl.hidden = !(sav > 0);
          if (savingAmt && sav > 0) savingAmt.textContent = money(sav);
        }
        if (oncePriceEl) oncePriceEl.textContent = money(v.price);
        /* grey "Full price" beside the one-time price (smallest bag only, per the brief) */
        if (fullPriceEl) fullPriceEl.hidden = !!cfg.fullPriceFirstOnly && sizes.length > 0 && sizeObj(state.size) !== sizes[0];
        /* optional price per kg (Price Marking Order) */
        var zg = sizeObj(state.size);
        if (zg && zg.grams) {
          var perKg = function (c) { return money(Math.round(c * 1000 / zg.grams)) + '/kg'; };
          if (kgSubEl && sv != null) kgSubEl.textContent = perKg(sv);
          if (kgOnceEl) kgOnceEl.textContent = perKg(v.price);
        }
      }
      /* title discount follows the chosen frequency's plan */
      if (subTitleEl && cfg.plans) {
        var pl = null; cfg.plans.forEach(function (x) { if (x.id === state.planId) pl = x; });
        var pct = pl && pl.pct != null ? pl.pct + '%' : cfg.subPct;
        if (!pct && v && subOf(v) != null) pct = Math.round((1 - subOf(v) / v.price) * 100) + '%';
        var tpl = subTitleEl.getAttribute('data-tpl') || 'Subscribe & Save [discount]';
        subTitleEl.textContent = tpl.replace('[discount]', pct || '').trim();
      }
      renderSavings(v);
      /* delivery dates + express tip follow the selected variant's stock */
      if (typeof paintArrive === 'function') paintArrive(v);

      /* ATC */
      var price = priceOf(v, state.plan);
      if (!v) {
        atc.disabled = true; atcLabel.textContent = cfg.unavailable || 'Unavailable';
      } else if (!v.available) {
        atc.disabled = true; atcLabel.textContent = cfg.soldOut || 'Sold out';
      } else {
        atc.disabled = false; atcLabel.textContent = atcText() + ' - ' + money(price);
      }

      /* form inputs */
/* Clear the value for one-time, not just disable it: Upnova's cart serialises disabled inputs too */
if (spIn) {
  var isSub = state.plan === 'sub' && state.planId != null;
  spIn.value = isSub ? state.planId : '';
  spIn.disabled = !isSub;
}
      if (v && v.id !== state.variantId) {
        state.variantId = v.id;
        idIn.value = v.id;
        if (!opts.silent) {
          /* lets the sticky ATC's <product-variants> resync its selects */
          idIn.dispatchEvent(new Event('change', { bubbles: true }));
          root._pdpbInternal = true;
          form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: v } }));
          root._pdpbInternal = false;
          /* media gallery + sticky bar listen on A's form id: tell them too, but only while B is live */
          var aForm = aFormId && document.getElementById(aFormId);
          if (aForm && aForm !== form && isLive()) {
            aForm.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: v, pdpb: true } }));
            /* a plain "variant:changed" dispatch updates price/image (ProductStickyForm
               listens for that), but the dropdowns themselves only resync their displayed
               value through <product-variants>'s own selectVariant() method - call it
               directly on every instance bound to A's form (A's own page picker, and the
               desktop sticky bar's dropdowns) */
            $$('product-variants[form-id="' + aFormId + '"]').forEach(function (pv) {
              if (typeof pv.selectVariant === 'function') pv.selectVariant(v.id);
            });
          }
          if (cfg.updateUrl && window.history && history.replaceState) {
            try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({ path: u.toString() }, '', u.toString()); } catch (e) {}
          }
        }
      }

      /* sticky ATC price (theme writes the one-time price on variant:changed, so we write after it) */
      if (v && isLive()) {
        $$('product-sticky-form .product-sticky-form__price, product-sticky-form .product-sticky-form__mobile-price').forEach(function (el) { el.textContent = money(price); });
        syncStickyAtc(v, price);
      }

      document.dispatchEvent(new CustomEvent('pdpb:change', { detail: { variant: v, plan: state.plan, sellingPlan: state.plan === 'sub' ? state.planId : null } }));
    }

    function setSize(val) { state.size = val; render(); }
    function setPlan(p) { if (p === 'sub' && !cfg.planId) return; state.plan = p; state.subWanted = false; render(); }

    /* ---------- wire: sizes + plans ---------- */
    sizes.forEach(function (s) { s.el.addEventListener('click', function () { setSize(s.value); }); });
    if (onceRow) onceRow.addEventListener('click', function () { setPlan('once'); });
    /* frequency field in the Mist band: opening it does not switch plan; changing it selects Subscribe */
    if (freqSel) {
      var days = function (o) {
        var t = (o.getAttribute('data-label') || o.textContent).toLowerCase(), m = t.match(/(\d+)\s*(day|week|month|year)/);
        if (!m) return 9999;
        return Number(m[1]) * ({ day: 1, week: 7, month: 30, year: 365 })[m[2]];
      };
      var sel0 = freqSel.value;
      [].slice.call(freqSel.options).sort(function (a, b) { return days(a) - days(b); }).forEach(function (o) { freqSel.appendChild(o); });
      freqSel.value = sel0;
      freqSel.addEventListener('click', function (e) { e.stopPropagation(); });
      freqSel.addEventListener('keydown', function (e) { e.stopPropagation(); });
      freqSel.addEventListener('change', function () {
        state.planId = Number(freqSel.value);
        var o = freqSel.options[freqSel.selectedIndex];
        if (freqLabel && o) freqLabel.textContent = o.getAttribute('data-label') || o.textContent;
        setPlan('sub');
      });
    }
    if (subCard) {
      subCard.addEventListener('click', function () { setPlan('sub'); });
      subCard.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPlan('sub'); } });
    }

    /* ---------- wire: grind combo-box (desktop list / phone bottom sheet) ---------- */
    var gBtn = $('.nw-gbtn', root), gBox = $('.nw-gbox', root);
    if (gBtn && gBox) {
      var gOpts = $$('.nw-gopt', gBox);
      var gVal = $('.nw-gval', gBtn), gIc = $('.nw-gsel-ic', gBtn);
      var openG = function () {
        gBox.hidden = false; gBtn.setAttribute('aria-expanded', 'true');
        var i = -1; gOpts.forEach(function (o, k) { if (o.getAttribute('aria-selected') === 'true') i = k; });
        (gOpts[i < 0 ? 0 : i] || gBtn).focus({ preventScroll: true });
      };
      var closeG = function (focusBtn) { gBox.hidden = true; gBtn.setAttribute('aria-expanded', 'false'); if (focusBtn) gBtn.focus({ preventScroll: true }); };
      var pickG = function (o, kb) {
        var val = o.getAttribute('data-grind');
        state.grind = val; state.grindChosen = true;
        gOpts.forEach(function (x) { x.setAttribute('aria-selected', String(x === o)); });
        gVal.textContent = val;
        gBtn.classList.add('is-set'); gBtn.classList.remove('is-err');
        var icon = o.getAttribute('data-icon');
        if (gIc) { gIc.hidden = !icon; gIc.innerHTML = icon ? '<img src="' + icon + '" alt="" width="28" height="28">' : ''; }
        if (gErr) gErr.hidden = true;
        closeG(kb);
        render();
      };
      gBtn.addEventListener('click', function () { gBox.hidden ? openG() : closeG(true); });
      gBtn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openG(); } });
      gOpts.forEach(function (o, i) {
        o.addEventListener('click', function (e) { pickG(o, e.detail === 0); });
        o.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); gOpts[Math.min(i + 1, gOpts.length - 1)].focus(); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); gOpts[Math.max(i - 1, 0)].focus(); }
          else if (e.key === 'Home') { e.preventDefault(); gOpts[0].focus(); }
          else if (e.key === 'End') { e.preventDefault(); gOpts[gOpts.length - 1].focus(); }
          else if (e.key === 'Escape') { e.preventDefault(); closeG(true); }
          else if (e.key === 'Tab') { closeG(false); }
        });
      });
      $$('[data-close]', gBox).forEach(function (x) { x.addEventListener('click', function () { closeG(true); }); });
      document.addEventListener('click', function (e) {
        var wrap = $('.nw-gsel', root);
        if (!gBox.hidden && wrap && !wrap.contains(e.target)) closeG(false);
      });

      /* optional: block add to cart until a grind is picked (off by default = same as variant A) */
      document.addEventListener('submit', function (e) {
        if (e.target !== form || !cfg.requireGrind || state.grindChosen) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (gErr) gErr.hidden = false;
        gBtn.classList.add('is-err');
        gBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(openG, 350);
      }, true);
      root._pdpbOpenGrind = openG;
    }

    /* ---------- blend swatches (pods): same look as variant A; "View Details" opens A's coffee pop-up ---------- */
    var blendBtns = $$('.nw-blend', root), blendTitle = $('[data-blend-title]', root);
    var paintBlends = function () {
      blendBtns.forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-grind') === state.grind)); });
      if (blendTitle && state.grind) blendTitle.textContent = state.grind.split('(')[0].trim();
    };
    blendBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.grind = b.getAttribute('data-grind'); state.grindChosen = true; paintBlends(); render(); });
    });
    $$('[data-coffee-vd]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var ov = document.getElementById('coffeeOverlay');
        /* A's pop-up sits inside A's blocks, which are hidden while B is live: move it to <body> so it can show */
        if (ov && ov.parentNode !== document.body) document.body.appendChild(ov);
        if (typeof window.openCoffeePopup === 'function') window.openCoffeePopup(btn);
      });
    });
    root._pdpbPaintBlends = paintBlends;

    /* keep in sync if something else changes the variant (e.g. the sticky bar's selects on desktop) */
    form.addEventListener('variant:changed', function (e) {
      if (root._pdpbInternal) return;
      var v = e.detail && e.detail.variant; if (!v || !v.options) return;
      var mine = byId(v.id); if (!mine) return;
      state.variantId = v.id;
      if (gi >= 0) state.grind = mine.options[gi];
      if (si >= 0) state.size = mine.options[si];
      if (root._pdpbPaintBlends) root._pdpbPaintBlends();
      render({ silent: true });
    });
    /* the sticky bar's own desktop size/grind dropdowns are bound to A's form - when B is
       live, mirror a change made there back into B (price, tiles, ATC form all follow) */
    var aFormEl = aFormId && document.getElementById(aFormId);
    if (aFormEl && aFormEl !== form) {
      aFormEl.addEventListener('variant:changed', function (e) {
        if (!isLive() || (e.detail && e.detail.pdpb)) return; /* ignore the echo we send to A ourselves */
        var v = e.detail && e.detail.variant; if (!v || !v.options) return;
        var mine = byId(v.id); if (!mine) return;
        if (gi >= 0) state.grind = mine.options[gi];
        if (si >= 0) state.size = mine.options[si];
        render({ silent: true }); /* leaves state.variantId stale on purpose, so render() below sees v.id !== state.variantId and actually writes idIn.value = v.id */
      });
    }
    /* ---------- perks under the button: "How it works" / "Need it faster?" tips ---------- */
    var tipBtns = $$('[data-tip]', root);
    var hoverOK = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
    var setTip = function (btn, open) {
      var tip = document.getElementById(btn.getAttribute('aria-controls'));
      if (!tip) return;
      tip.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      btn.parentNode.classList.toggle('is-open', open);
    };
    var closeTips = function (except) { tipBtns.forEach(function (b) { if (b !== except) setTip(b, false); }); };
    tipBtns.forEach(function (btn) {
      var holder = btn.parentNode, t = null;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = btn.getAttribute('aria-expanded') !== 'true' || btn._hoverOpened;
        btn._hoverOpened = false;
        closeTips(btn); setTip(btn, open);
      });
      if (hoverOK) {
        holder.addEventListener('mouseenter', function () { clearTimeout(t); if (btn.getAttribute('aria-expanded') !== 'true') { closeTips(btn); setTip(btn, true); btn._hoverOpened = true; } });
        holder.addEventListener('mouseleave', function () { t = setTimeout(function () { btn._hoverOpened = false; setTip(btn, false); }, 120); });
      }
    });
    if (tipBtns.length) {
      document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('.nw-dl')) closeTips(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTips(); });
    }

    /* arrival window, recalculated in UK time so a cached page never shows an old date:
       N working days from today, Sunday never counts, Saturday only if the block setting says so.
       Out of stock / oversold variant (tracked stock <= 0): the window moves back by N days (7 by default),
       and the "Need it faster?" express option is hidden. */
    var arrive = $('[data-arrive]', root), arriveRange = null;
    var xWrap = $('[data-express]', root);
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var arrSat = arrive && arrive.getAttribute('data-sat') === 'true';
    var isWorking = function (d) { var w = d.getUTCDay(); return !(w === 0 || (w === 6 && !arrSat)); };
    var addDays = function (d, n) { return new Date(d.getTime() + n * 864e5); };
    var toWorking = function (d) { while (!isWorking(d)) d = addDays(d, 1); return d; };
    var fmtRange = function (from, to) {
      var dm = function (d) { return d.getUTCDate() + ' ' + MON[d.getUTCMonth()]; };
      if (from.getTime() === to.getTime()) return dm(to);
      return from.getUTCMonth() === to.getUTCMonth() ? from.getUTCDate() + '-' + dm(to) : dm(from) + ' - ' + dm(to);
    };
    if (arrive) {
      try {
        var dMin = Number(arrive.getAttribute('data-min')) || 2, dMax = Math.max(dMin, Number(arrive.getAttribute('data-max')) || dMin);
        var ukParts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
        var pv = function (k) { for (var i = 0; i < ukParts.length; i++) if (ukParts[i].type === k) return Number(ukParts[i].value); return 0; };
        var day = new Date(Date.UTC(pv('year'), pv('month') - 1, pv('day'), 12));
        var from = null, to = null, bd = 0;
        for (var i = 0; i < 21 && !to; i++) {
          day = addDays(day, 1);
          if (!isWorking(day)) continue;
          bd++;
          if (bd === dMin) from = day;
          if (bd === dMax) to = day;
        }
        if (from && to) arriveRange = { from: from, to: to, oosDays: Number(arrive.getAttribute('data-oos-days') || 7) };
      } catch (e) {}
    }
    function paintArrive(v) {
      if (!arriveRange) return;
      var oos = !!(v && v.oos), r = arriveRange, from = r.from, to = r.to;
      if (oos && r.oosDays > 0) { from = toWorking(addDays(r.from, r.oosDays)); to = toWorking(addDays(r.to, r.oosDays)); }
      var rL = $('.nw-pk-r', arrive);
      if (rL) { var t = fmtRange(from, to); if (rL.textContent !== t) rL.textContent = t; }
      /* no express option while the selected variant is out of stock (client request) */
      if (xWrap) {
        if (oos) { var xb = $('[data-tip]', xWrap); if (xb) setTip(xb, false); }
        xWrap.hidden = oos;
      }
    }
    root._pdpbPaintArrive = paintArrive;

    /* ---------- FAQ accordions ---------- */
    $$('.nw-q', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', String(open));
        var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !open;
      });
    });

    /* ---------- review carousel: swipe (touch + mouse drag), dots, arrow keys ---------- */
    var track = $('.nw-rev-track', root);
    if (track) {
      var hang = function () { $$('.nw-rev-q', root).forEach(function (q) { var o = $('.oq', q); if (o) q.style.setProperty('--qw', o.getBoundingClientRect().width + 'px'); }); };
      hang(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(hang);
      var slides = $$('.nw-rev-s', track), dots = $$('.nw-rev-dot', root), n = slides.length, cur = 0;
      var go = function (i, animate) {
        cur = Math.max(0, Math.min(n - 1, i));
        track.style.transition = animate === false ? 'none' : '';
        track.style.transform = 'translateX(' + (-cur * 100) + '%)';
        dots.forEach(function (d, k) { if (k === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        slides.forEach(function (sl, k) { sl.setAttribute('aria-hidden', String(k !== cur)); });
        /* arrows: light (disabled) image on the first / last review, as in the "Clean Coffee" section */
        [[revPrev, cur === 0], [revNext, cur === n - 1]].forEach(function (a) {
          var btn = a[0], off = a[1]; if (!btn) return;
          btn.disabled = off;
          var im = btn.querySelector('img'); if (im) im.src = im.getAttribute(off ? 'data-off' : 'data-on');
        });
      };
      var revPrev = $('[data-rev-prev]', root), revNext = $('[data-rev-next]', root);
      if (revPrev) revPrev.addEventListener('click', function () { go(cur - 1); });
      if (revNext) revNext.addEventListener('click', function () { go(cur + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-i'))); }); });
      var wrap = track.parentNode;
      wrap.setAttribute('tabindex', '0');
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });
      if (n > 1) {
        var sx = 0, sy = 0, dx = 0, t0 = 0, drag = false, lock = null, pid = null;
        var w = function () { return track.clientWidth || 1; };
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          drag = true; lock = null; sx = e.clientX; sy = e.clientY; dx = 0; t0 = Date.now(); pid = e.pointerId;
          track.style.transition = 'none';
        });
        track.addEventListener('pointermove', function (e) {
          if (!drag || e.pointerId !== pid) return;
          var mx = e.clientX - sx, my = e.clientY - sy;
          if (lock === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) {
            lock = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
            if (lock === 'x') {
              /* touch is captured implicitly; capturing again fires lostpointercapture mid-swipe */
              if (e.pointerType === 'mouse') { try { track.setPointerCapture(pid); } catch (err) {} }
              track.classList.add('is-drag');
            }
          }
          if (lock !== 'x') return;
          e.preventDefault();
          dx = mx;
          /* rubber-band at the first and last review */
          if ((cur === 0 && dx > 0) || (cur === n - 1 && dx < 0)) dx = dx / 3;
          track.style.transform = 'translateX(calc(' + (-cur * 100) + '% + ' + dx + 'px))';
        });
        var end = function (e) {
          if (!drag || (e && e.pointerId !== pid)) return;
          drag = false; track.classList.remove('is-drag');
          if (lock === 'x') {
            var fast = Math.abs(dx) > 20 && Date.now() - t0 < 250;
            if (dx < -w() * 0.18 || (fast && dx < 0)) go(cur + 1);
            else if (dx > w() * 0.18 || (fast && dx > 0)) go(cur - 1);
            else go(cur);
          } else { track.style.transition = ''; }
          lock = null;
        };
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        /* a drag must not trigger clicks or text selection */
        track.addEventListener('click', function (e) { if (Math.abs(dx) > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      go(0, false);
      window.addEventListener('resize', function () { go(cur, false); });
    }

    /* ---------- lab modal ---------- */
    var labRoot = $('[data-lab-root]', root), labModal = labRoot && $('[data-lab-modal]', labRoot);
    if (labModal) {
      moveToBody(labRoot);
      var lastFocus = null;
      var openLab = function () { lastFocus = document.activeElement; labModal.classList.add('open'); document.body.classList.add('pdpb-lock'); var c = $('[data-lab-close]', labModal); if (c) c.focus(); };
      var closeLab = function () { labModal.classList.remove('open'); document.body.classList.remove('pdpb-lock'); if (lastFocus) lastFocus.focus({ preventScroll: true }); };
      $$('[data-lab-open]', root).forEach(function (t) {
        t.addEventListener('click', openLab);
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLab(); } });
      });
      labModal.addEventListener('click', function (e) { if (e.target === labModal) closeLab(); });
      $('[data-lab-close]', labModal).addEventListener('click', closeLab);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && labModal.classList.contains('open')) closeLab(); });
    }

    /* lab modal: report thumbnail "+" opens page 1 full screen (dark overlay, as the design) */
    var zView = $('[data-lab-zoom-view]', root), zBtn = labModal && $('[data-lab-zoom]', labModal);
    if (zView && zBtn) {
      moveToBody(zView);
      var closeZ = function () { zView.hidden = true; zBtn.focus({ preventScroll: true }); };
      zBtn.addEventListener('click', function () { zView.hidden = false; var x = $('[data-lab-zoom-close]', zView); if (x) x.focus({ preventScroll: true }); });
      zView.addEventListener('click', function (e) { if (e.target === zView || e.target.closest('[data-lab-zoom-close]')) closeZ(); });
      /* Esc closes the page view first, then the lab modal */
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !zView.hidden) { e.stopImmediatePropagation(); closeZ(); } }, true);
    }

    /* ---------- grind guide modal ("Not sure which to choose?") ---------- */
    var gm2 = $('[data-gm]', root);
    if (gm2) {
      moveToBody(gm2);
      var gmFrom = null;
      var openGm = function () { gmFrom = document.activeElement; gm2.classList.add('open'); document.body.classList.add('pdpb-lock'); var x = $('[data-gm-close]', gm2); if (x) x.focus({ preventScroll: true }); };
      var closeGm = function () { gm2.classList.remove('open'); document.body.classList.remove('pdpb-lock'); if (gmFrom) gmFrom.focus({ preventScroll: true }); };
      $$('[data-gm-open]', root).forEach(function (b) { b.addEventListener('click', openGm); });
      $('[data-gm-close]', gm2).addEventListener('click', closeGm);
      gm2.addEventListener('click', function (e) { if (e.target === gm2) closeGm(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && gm2.classList.contains('open')) closeGm(); });
    }

    /* ---------- monthly gifts modal ---------- */
    var gm = $('[data-gifts-modal]', root);
    if (gm) {
      moveToBody(gm);
      var page = 0, trackG = $('.bc-track', gm), prog = $('.bc-progress', gm), prev = $('.bc-prev', gm), next = $('.bc-next', gm);
      trackG.innerHTML = GIFTS.map(function (m) {
        return '<div class="bc-month"><div class="bc-mlabel">' + m.label + '</div>' + m.items.map(function (it) {
          return '<div class="bc-item"><span class="bc-thumb" style="background-image:url(\'' + it.img + '\')"></span><span class="bc-txt"><span class="bc-line">' + it.gift + '</span><span class="bc-line"><span class="bc-price">' + it.price + '</span><span class="bc-free">FREE</span></span></span></div>';
        }).join('') + '</div>';
      }).join('');
      var mobile = function () { return window.matchMedia('(max-width:480px)').matches; };
      var pv = function () { return mobile() ? 2 : 4; };
      var pages = function () { return Math.max(1, Math.ceil(GIFTS.length / pv())); };
      var paint = function () {
        var P = pages(), n = pv(); page = Math.min(Math.max(page, 0), P - 1);
        var col = 100 / n, maxOff = Math.max(0, GIFTS.length * col - 100), off = Math.min(page * 100, maxOff);
        trackG.style.transform = 'translateX(-' + off + '%)';
        var frac = P === 1 ? 1 : page / (P - 1), html = '';
        if (mobile()) {
          html += '<div class="bc-rail" style="left:0;right:0"></div><div class="bc-fill" style="left:0;width:' + (frac * 100) + '%"></div>';
          for (var i = 0; i < P; i++) html += '<div class="bc-node' + (i <= page ? ' on' : '') + '" style="left:' + (P === 1 ? 0 : (i / (P - 1)) * 100) + '%"></div>';
        } else {
          var a = (0.5 / n) * 100, b = ((n - 0.5) / n) * 100;
          html += '<div class="bc-rail" style="left:' + a + '%;right:' + (100 - b) + '%"></div><div class="bc-fill" style="left:' + a + '%;width:' + (frac * (b - a)) + '%"></div>';
          for (var j = 0; j < n; j++) { var nf = n === 1 ? 0 : j / (n - 1); html += '<div class="bc-node' + (nf <= frac + 0.001 ? ' on' : '') + '" style="left:' + ((j + 0.5) / n) * 100 + '%"></div>'; }
        }
        prog.innerHTML = html;
        prev.disabled = page === 0; next.disabled = page >= P - 1;
      };
      $$('[data-gp]', gm).forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); page += Number(btn.getAttribute('data-gp')); paint(); }); });
      var sx = null, vp = $('.bc-viewport', gm);
      vp.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      vp.addEventListener('pointerup', function (e) { if (sx === null) return; var d = e.clientX - sx; sx = null; if (Math.abs(d) < 50) return; page += d < 0 ? 1 : -1; paint(); });
      var openGifts = function (e) { if (e) { e.preventDefault(); e.stopPropagation(); } page = 0; paint(); gm.classList.add('open'); document.body.classList.add('pdpb-lock'); };
      var closeGifts = function () { gm.classList.remove('open'); document.body.classList.remove('pdpb-lock'); };
      $$('[data-gifts-open]', root).forEach(function (a) { a.addEventListener('click', openGifts); });
      gm.addEventListener('click', function (e) { if (e.target === gm) closeGifts(); });
      $('[data-gifts-close]', gm).addEventListener('click', closeGifts);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && gm.classList.contains('open')) closeGifts(); });
      window.addEventListener('resize', function () { if (gm.classList.contains('open')) paint(); });
    }

    /* A/B switch: when B goes live point the sticky add-to-cart bar at B's form (and back when A returns) */
    function onAb() {
      var live = isLive();
      $$('product-sticky-form [type="submit"][form]').forEach(function (btn) {
        if (!btn.hasAttribute('data-pdpb-a-form')) btn.setAttribute('data-pdpb-a-form', btn.getAttribute('form'));
        btn.setAttribute('form', live ? root.getAttribute('data-form-id') : btn.getAttribute('data-pdpb-a-form'));
      });
      render({ silent: true });
    }
    document.addEventListener('pdpb:ab', onAb);

    /* EXP-018: tag the cart with the arm the visitor saw ("variant" = B visible, "control" = A visible) */
    if (cfg.armAttr && !root._pdpbArm) {
      root._pdpbArm = true;
      document.addEventListener('variant:added', function () {
        var attrs = {}; attrs[cfg.armAttr] = isLive() ? 'variant' : 'control';
        try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }); } catch (e) {}
      });
    }

    render({ silent: true });
    if (isLive()) onAb();
  }

  function boot() { $$('[data-pdpb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();